<template>
    <div :class="clContainer(isSelected ? clMod('selected') : '')">
        <div :class="clSub('head')">
            <h2 v-tif="{ path: 'title', args: processedMessage }"></h2>
            <small :class="clSub('date')">{{ dateOutput(processedMessage.created_at) }}</small>
        </div>

        <div :class="clSub('body')">
            <div :class="clSub('info')">
                <div v-if="processedMessage.text" :class="clSub('text')" v-html="processedMessage.text" class="mb-xs"></div>
                <div v-else v-tif="{ path: 'text', args: processedMessage }" class="mb-sm"></div>

                <div v-if="processedMessage.data.additionalText" class="mb-sm">
                    <div v-for="(additionalText, index) in processedMessage.data.additionalText" :key="index" v-html="additionalText"></div>
                </div>

                <component v-if="processedMessage.category in categoryMessageComponents" :is="categoryMessageComponents[processedMessage.categoryName]" :message="processedMessage"></component>
                <component v-else-if="processedMessage.type in typeMessageComponents" :is="typeMessageComponents[processedMessage.typeName]" :message="processedMessage"></component>
                <component v-else-if="processedMessage.source_type in sourceTypeMessageComponents" :is="sourceTypeMessageComponents[processedMessage.source_type]" :message="processedMessage"></component>
                <component v-else-if="processedMessage.sourceTypeName in sourceTypeMessageComponents" :is="sourceTypeMessageComponents[processedMessage.sourceTypeName]" :message="processedMessage"></component>
            </div>

            <ul v-if="processedMessage.data.pictures" :class="clSub('pictures', 'list-reset list-h')">
                <li v-for="(file, index) in processedMessage.data.pictures" :key="index" :class="clSub('picture')">
                    <button class="btn-plain" @click="showFile(index, $event)">
                        <img :src="`/files/show/${file.route}`" />
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import NeedsSetableCssClasses from '../Mixins/NeedsSetableCssClasses';
import { toDate } from '../../helpers/common';

export default {
    mixins: [ NeedsSetableCssClasses ],
    inject: {
        categoryMessageComponents: { default: {} },
        typeMessageComponents: { default: {} },
        sourceTypeMessageComponents: { default: {} },
        generateTranslationsKeyPaths: { default: null }
    },
    props: {
        baseClass: {
            type: String,
            default: 'message'
        },
        message: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        isSelected: {
            type: Boolean,
            default: false
        },
        dataProcessing: {
            type: Function,
        }
    },
    mounted() {
        if(this.isSelected) {
            this.$el.parentElement.scrollIntoView(false);
        }
    },
    computed: {
        translationsKeyPaths() {
            if(this.generateTranslationsKeyPaths) {
                return this.generateTranslationsKeyPaths(this.message);
            }

            return [
                `messages.${this.message.categoryName}.${this.message.subCategoryName}.${this.message.typeName}`
            ];
        },
        processedMessage() {
            return this.dataProcessing ? this.dataProcessing(this.message) : this.message;
        }
    },
    methods: {
        dateOutput(dateString) {
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: '2-digit' };
            const date = toDate(dateString);

            return date.toLocaleDateString(undefined, options) + ' - ' + date.toLocaleTimeString(undefined, { hour: '2-digit', minute:'2-digit' });
        },
        showFile(index, triggerEvent = null) {
            if(this.$windows) {
                this.$windows.showFilesWindow('Bilder Meldung', this.message.data.pictures, index, triggerEvent);
            } else {
                console.error('$windows for opening the files window is missing');
            }
        }
    }
}
</script>
<style>

.message-card [class$="_hidde_desc"] .message__info{
  display: none;
}
</style>